import styled from "styled-components";

export const DetailsItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
